import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import fr from "./fr.json";

const STORAGE_KEY = "gatherly_language";

export const languages = [
  { code: "en", label: "English" },
  { code: "fr", label: "Français" },
];

const supported = languages.map((language) => language.code);

// Saved choice first, then the browser's language, then English.
const initialLanguage = (() => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (supported.includes(stored)) return stored;
  } catch {
    // ignore storage failures (private browsing, etc.)
  }
  const browser = (navigator.language || "").slice(0, 2).toLowerCase();
  return supported.includes(browser) ? browser : "en";
})();

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr } },
  lng: initialLanguage,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

document.documentElement.lang = initialLanguage;

i18n.on("languageChanged", (lng) => {
  document.documentElement.lang = lng;
  try {
    localStorage.setItem(STORAGE_KEY, lng);
  } catch {
    // ignore storage failures (private browsing, etc.)
  }
});

export default i18n;
